import { render, staticRenderFns } from "./VirtualTourCard.vue?vue&type=template&id=35956355&scoped=true&"
import script from "./VirtualTourCard.vue?vue&type=script&lang=js&"
export * from "./VirtualTourCard.vue?vue&type=script&lang=js&"
import style0 from "./VirtualTourCard.vue?vue&type=style&index=0&id=35956355&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35956355",
  null
  
)

export default component.exports